import {ThemeProvider} from '@mds/mds-reactjs-library'
import {FC, ReactNode} from 'react'

import theme from './theme'

interface GlobalThemeProps {
  children?: ReactNode
}

export const GlobalTheme: FC<GlobalThemeProps> = ({children}) => (
  <ThemeProvider customTheme={theme}>{children}</ThemeProvider>
)
